import React from 'react';
import { Logo } from '../common/Logo';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-900 py-10 border-t border-slate-800">
      <div className="container mx-auto px-6 text-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex items-center space-x-3">
            <Logo variant="horizontal" width={220} height={44} />
          </div>
          <p className="text-gray-400 text-sm">&copy; {new Date().getFullYear()} DevDriven. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
